import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import fileDownload from "js-file-download";
import { url } from "../utils/Constants";
import { validateField } from "../utils/helpers";

export const UserMaintanenceSlice = createSlice({
  name: "UserMaintanenceList",
  initialState: {
    UserMaintanenceData: [],
  },
  reducers: {
    setError: (state) => {
      state.error = true;
    },
    setUserMaintanenceData: (state, { payload }) => {
      state.error = false;
      state.UserMaintanenceData = payload;
    },
    updateUserMaintanenceData: (state, { payload }) => {
      state.error = false;

      const existingObject = state.UserMaintanenceData[0]; // Choose the appropriate index

      console.log(existingObject, " existingone ");
      // Create a new object based on the existing one
      const newestUser = {
        // ...existingObject,
        sno: "",
        Enterprise_ID: "",
        Supervisor: "",
        "Automation Engineer": "no",
        "Backend Developer": "no",
        "Full Stack Engineer": "no",
        "System Engineer": "no",
        "Web Developer": "no",
        Admin: "no",
        isActive: "yes",
      };

      const newUserObject = {
        // Clone the existing object
        // ...existingObject,
        ...newestUser,
        Enterprise_ID: payload.username,
        Supervisor: payload.supname,
        Admin: "",
        isActive: "yes",
      };

      console.log(newUserObject, " newUserObject ");
      console.log("state.userMaintenanceData", state.UserMaintanenceData[0]);
      // Add the new object to the data array
      state.UserMaintanenceData.push(newUserObject);
      state.UserMaintanenceData.map((item, i) => {
        item.sno = i + 1;
      });
    },
  },
});

export const { setError, setUserMaintanenceData, updateUserMaintanenceData } =
  UserMaintanenceSlice.actions;

export default UserMaintanenceSlice.reducer;

export function getUserMaintanenceData() {
  return (dispatch) => {
    axios
      .get(`${url}/fetchusermaintanencedata`, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let newArray;
        if (res.data != undefined && res.data != null) {
          newArray = res.data.map((item, index) => {
            const newItem = {
              sno: index + 1,
              ...item,
            };
            return newItem;
          });
        }
        console.log(res.data, " fet user maintenance");
        dispatch(setUserMaintanenceData(newArray));
        // console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
// const isAdminUser = () =>{

// }

export function addUser(username, supname) {
  return (dispatch) => {
    if (!validateField(username) || !validateField(supname)) {
      dispatch(setError("Please enter valid values"));
      return;
    }
    axios
      .post(
        `${url}/adduser`,
        { username, supname },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(updateUserMaintanenceData({ username, supname }));
        console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function submitUserRoles(roles) {
  console.log(roles);
  return (dispatch) => {
    axios
      .post(
        `${url}/adduserroles`,
        { roles },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        //  dispatch(updateUser(username));
        console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function updateSupervisor(Supervisor, Enterprise_ID) {
  return (dispatch) => {
    axios
      .put(
        `${url}/updateSupervisor`,
        { Supervisor, Enterprise_ID },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        //  dispatch(updateUser(username));
        console.log("updated supervisor details");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function deleteEnterpriseID(Enterprise_ID_Del) {
  console.log("Enterprise id in redux", Enterprise_ID_Del);
  return (dispatch) => {
    axios
      .delete(`${url}/deleteEnterpriseID/${Enterprise_ID_Del}`, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("deleted EnterpriseID");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.log("error in deleting Enterprise ID is", err);
      });
  };
}

export function downloadUserRoles() {
  return (dispatch) => {
    axios
      .get(
        `${url}/downloadExcel`,
        {
          responseType: "blob",
        },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        fileDownload(res.data, `User Roles.xlsx`);
      })
      .catch((err) => {
        console.error("error is", err);
      });
  };
}

export function uploadUserRoles(formData) {
  return (dispatch) => {
    axios
      .post(`${url}/uploaduserrole`, formData, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          // "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // then print response status
        console.log(res);
      })
      .catch((err) => {
        // then print response status
        dispatch(setError(err));
        console.error("upload fail");
      });
  };
}
